import { logout, getInfo } from '@/api/user'
import { getToken, removeToken } from '@/utils/cookies'
import { resetRouter } from '@/router'
import { list } from '@/api/team'

const state = {
  token: getToken(),
  userinfo: '',
  team_token: '',
  team_selected: null,
  team_list: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userinfo) => {
    state.userinfo = userinfo
  },
  SET_TEAM_TOKEN: (state, team_token) => {
    state.team_token = team_token
  },
  SET_TEAM_SELECTED: (state, team_selected) => {
    state.team_selected = team_selected
  },
  SET_TEAM_LIST: (state, team_list) => {
    state.team_list = team_list
  }
}

const actions = {
  // set user token
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },
  // get user info
  getInfo({ commit }) {
    getInfo().then(res => {
      commit('SET_USERINFO', res.data)
    }).catch(() => {})
  },
  // set team token
  setTeamToken({ commit }, team_token) {
    commit('SET_TEAM_TOKEN', team_token)
  },
  // set team selected
  setTeamSelected({ commit }, team_selected) {
    commit('SET_TEAM_SELECTED', team_selected)
  },
  // get team list
  getTeamList({ commit }) {
    commit('SET_TEAM_LIST', [])
    list().then(res => {
      commit('SET_TEAM_LIST', res.data.list)

      let leaderItem = null
      let teamSelected = null
      const formatData = () => {
        return new Promise(resolve => {
          res.data.list.forEach(item => {
            if (item.is_leader) {
              leaderItem = item
            }

            if (item['team_id'] === state.team_token) {
              teamSelected = item
            }
          })

          resolve()
        })
      }
      formatData().then(() => {
        if (teamSelected) {
          commit('SET_TEAM_SELECTED', teamSelected)
        } else {
          if (leaderItem.team_id !== state.team_token) {
            commit('SET_TEAM_TOKEN', leaderItem.team_id)
          }
          commit('SET_TEAM_SELECTED', leaderItem)
        }
      })
    }).catch(() => {})
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_TOKEN', '')
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
